var cio_datamodel = require("cio-datamodel");

var logoDataToSVG = function (data) {
    console.assert(data instanceof cio_datamodel.LogoData);

    if (data.type() === "svg")
        return '<g style="all:initial;" ' +
                'transform="translate(' + data.pos().getX() + ' ' + data.pos().getY() + ') ' +
                    'rotate(' + data.angle() + ') scale(' + data.getScaleX() + ', ' + data.getScaleY() + ')" '  +
                '>' +
                data.data() +
                '</g>';
    else
        throw new Error("Unknown logo type: "+data.type());
};

module.exports = logoDataToSVG;

